import DataList, { DataRow } from '@/ui/components/DataList';
import DualTime from '@/ui/components/DualTime';
import Heading from '@/ui/components/Heading';

import { Props } from './types';
const CardOrderDetails = ({ cardOrder }: Props) => {
  return (
    <div data-testid={`card-order-details-${cardOrder.id}`}>
      <Heading value={4} text="Card Order Details" />

      <DataList>
        <DataRow
          label="Ordered At"
          content={<DualTime dateTime={new Date(cardOrder.ordered_at)} />}
        />
        <DataRow label="Status" content={cardOrder.status} />
        {cardOrder.fail_reason && <DataRow label="Fail Reason" content={cardOrder.fail_reason} />}
      </DataList>
    </div>
  );
};

export default CardOrderDetails;
